import type { GameModule } from '../types';
import Page from './Page';

// Thimbles — cups-and-ball shell game. UI-ONLY preview for now (no backend).
// Stays is_locked=1 in the games table until the real engine/wallet is wired.
const thimbles: GameModule = {
  id: 'thimbles',
  displayName: 'Thimbles',
  tag: 'Arcade',
  theme: {
    // magenta house theme (≈ #971f71 / #892b6c). NOTE: the DB games.theme_gradient
    // takes precedence on the lobby tile — keep the two in sync. These arbitrary
    // hex classes are force-generated via the tailwind.config.js safelist.
    gradient: 'from-[#a8267f] to-[#892b6c]',
    emoji: '🎩',
    logo: '/games/thimbles/Logo.png',
  },
  orientation: 'portrait',
  adminIcon: 'casino',
  adminTheme: {
    headerFrom: 'from-blue-900',
    headerTo: 'to-amber-900',
    ring: 'focus:ring-amber-500',
    accent: 'bg-amber-600',
    accentHover: 'hover:bg-amber-500',
    dot: 'bg-amber-400',
    softBg: 'bg-amber-500/10',
    rangeAccent: 'accent-amber-500',
    badgeClasses: 'bg-amber-500/20 text-amber-300 border-amber-500/30',
  },
  Page,
};

export default thimbles;
